body.on('click', '#lp-init-timer-lockout', function () {
    let lpPriceTypesRadio = $('.LP_price_type_radio:checked');

    if (lpPriceTypesRadio.length === 0) {
        return;
    }

    let data = {
        type: $(lpPriceTypesRadio).val(),
    };

    storeTimerLockout(
        data,
        'LP',
        callbackTimerLockoutLP
    );
});

function callbackTimerLockoutLP() {
    $('.lp_after_wrapper').removeClass('d-none');
}
